import { memo, useCallback } from 'react';
import { Button } from '@workspace/ui/common';
import { cn } from '@workspace/lib';

interface QuickPromptsProps {
  prompts: string[];
  onPromptClick: (prompt: string) => void;
  className?: string;
  buttonClassName?: string;
}

function QuickPromptsComponent({ prompts, onPromptClick, className, buttonClassName }: QuickPromptsProps) {
  if (!prompts || prompts.length === 0) {
    return null;
  }

  const handlePromptClick = useCallback(
    (prompt: string) => () => {
      onPromptClick(prompt);
    },
    [onPromptClick],
  );

  return (
    <div className={cn('flex flex-col gap-3', className)}>
      {prompts.map((prompt, index) => (
        <Button
          key={`prompt-${index}-${prompt.slice(0, 20)}`}
          onClick={handlePromptClick(prompt)}
          variant="primary"
          overrideClasses
          className={cn(
            'w-full',
            'px-md py-3',
            'flex justify-center items-center gap-3xs self-stretch',
            'bg-white',
            'border border-primary rounded-full',
            'font-openSans font-semibold text-sm',
            'text-primary',
            'cursor-pointer',
            'hover:border-primary-500',
            'active:border-2',
            'active:border-primary',
            buttonClassName,
          )}
        >
          {prompt}
        </Button>
      ))}
    </div>
  );
}

export const QuickPrompts = memo(QuickPromptsComponent);
